import type { UserAnswersDraft } from './UserAnswersDraft'
import type { UserInputDraft } from './UserInputDraft'

export interface ClaudeSessionMemory {
  readonly userInputDrafts: UserInputDraft[]
  readonly userAnswersDraft: UserAnswersDraft | null
}

export function createEmptyClaudeSessionMemory(): ClaudeSessionMemory {
  return {
    userInputDrafts: [],
    userAnswersDraft: null,
  }
}

export function clearClaudeSessionMemory(): ClaudeSessionMemory {
  return createEmptyClaudeSessionMemory()
}

export function withUserInputDrafts(
  memory: ClaudeSessionMemory,
  drafts: UserInputDraft[],
): ClaudeSessionMemory {
  return { ...memory, userInputDrafts: drafts }
}

export function withUserAnswersDraft(
  memory: ClaudeSessionMemory,
  draft: UserAnswersDraft | null,
): ClaudeSessionMemory {
  return { ...memory, userAnswersDraft: draft }
}

export function clearUserAnswersDraft(memory: ClaudeSessionMemory): ClaudeSessionMemory {
  return withUserAnswersDraft(memory, null)
}
